import { angularAMD } from "@pebblepad/amd";
import { textEditableDirectiveFactory } from "./TextEditableDirectiveFactory";

angularAMD.directive("contenteditable", textEditableDirectiveFactory("contenteditable"));
